export class ClientPackagePricing
{
    constructor(){
        this.searchOverrides = [];
        this.id = 0;
    }
    id: number;
    clientId: number;
    searchPackageId: number;
    clientPackageCost: number;
    clientPackageNotes: string;
    searchOverrides : SearchRecordClientPricing[];
    enableIncomeVerification : boolean;
    incomeVerificationAddOnPrice : number;

}   

export class SearchRecordClientPricing{
    id : number;
    clientId : number;
    searchPackageId : number;
    searchRecordId : number;
    clientSearchCost : number;
}



// export interface ClientPackageOverrides
// {
//     Id: number;
//     ClientId: number;
//     SearchPackageId: number;
//     ClientPackageCost: number;
//     ClientPackgeNotes: string;

//     SearchOverrides: ClientSearchRecordOverride[];
// }


// export interface ClientSearchRecordOverride
// {
//     Id: number;
//     ClientId: number;
//     SearchRecordId: number;
//     SearchPackageId: number;
//     ClientSearchCost: number;
// }